import React from 'react';
import useZibi from "../../zibi/UseZibi";
import Paper from "@mui/material/Paper";
import styled from "styled-components";
import {useLocation, useNavigate} from "react-router-dom";
import {addOrDeleteQueryParams} from "../../domain/queryHandler";

const WrapperStyled = styled.div`
    padding: 20px;
    display: grid;
    //grid-template-columns: 300px;
    grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
    grid-gap: 15px;
`;

const ItemStyled = styled.div`
    padding: 10px;
    position: relative;
    cursor: pointer;
`;

const Clients = () => {
    const history = useNavigate();
    const location = useLocation();

    const [clients] = useZibi('clients');

    const changeUrl = (query) => {
        history({
            search: query
        });
    };

    return (
        <WrapperStyled>
            {clients.map((client) => {
                return (
                    <Paper
                        onClick={()=>{
                            const urlToPush = addOrDeleteQueryParams(location, [{client: client._id}, {site: null}, {edge: null}]);
                            changeUrl(urlToPush);
                        }}
                        key={client._id} elevation={3}>
                        <ItemStyled>
                            {client.name}
                        </ItemStyled>
                    </Paper>
                );
            })}
        </WrapperStyled>
    );
};

export default Clients;